var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'text',
        label: 'Usuário',
        field: 'usuario'
      }, {
        type: 'date',
        label: 'Data Atendimento',
        field: 'dataAtendimento'
      }, {
        type: 'select',
        label: 'Negócio',
        field: 'negocio',
        options: ['Prospecção', 'Venda', 'Agendamento']
      }]
    }
  }), _c('TableApp', {
    ref: "prospects",
    attrs: {
      "titulo": "Atendimento",
      "textoBtn": "Novo",
      "api-url": "/prospect/lista",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('span', {
          staticClass: "text-dark-75font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.numero))])])])])]) : _vm._e(), props.field == 'cliente' ? _c('span', {
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('span', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(_vm._s(props.rowData.cliente))])])])])]) : _vm._e(), props.field == 'usuario' ? _c('span', {
          attrs: {
            "slot": "usuario"
          },
          slot: "usuario"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('span', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(_vm._s(props.rowData.usuario))])])])])]) : _vm._e(), props.field == 'dataAtendimento' ? _c('span', {
          attrs: {
            "slot": "dataAtendimento"
          },
          slot: "dataAtendimento"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('span', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.dataAtendimento, "DD/MM/YYYY")) + " ")])])])])]) : _vm._e(), props.field == 'negocio' ? _c('span', [props.rowData.negocio == 1 ? _c('span', {
          staticClass: "label label-lg label-inline label-light-warning"
        }, [_vm._v("Prospecção")]) : props.rowData.negocio == 2 ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Venda")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-primary"
        }, [_vm._v("Agendamento")])]) : _vm._e(), props.field == 'actions' ? _c('span', [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.visualizarProspect",
            modifiers: {
              "visualizarProspect": true
            }
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Visualizar',
            expression: "'Visualizar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-hover-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.selecionarAtendimento(props.rowData);
            }
          }
        }, [_c('Eye', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "visualizarProspect",
      "title": "Visualização do atendimento realizado",
      "centered": "",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_vm.atendimentoSelecionado ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-row', [_c('p', [_vm._v("Número: " + _vm._s(_vm.atendimentoSelecionado.numero))])])], 1) : _vm._e(), _vm.atendimentoSelecionado ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-row', [_c('p', [_vm._v("Cliente: " + _vm._s(_vm.atendimentoSelecionado.cliente))])])], 1) : _vm._e(), _vm.atendimentoSelecionado ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-row', [_c('p', [_vm._v("Contato: " + _vm._s(_vm.atendimentoSelecionado.contato))])])], 1) : _vm._e(), _vm.atendimentoSelecionado ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-row', [_c('p', [_vm._v("Resonsável: " + _vm._s(_vm.atendimentoSelecionado.responsavel))])])], 1) : _vm._e(), _vm.atendimentoSelecionado ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-row', [_c('p', [_vm._v("OBs: " + _vm._s(_vm.atendimentoSelecionado.observacao))])])], 1) : _vm._e(), _vm.urlAnexo1 ? _c('div', [_c('b-row', [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.urlAnexo1,
      "target": "_blank"
    }
  }, [_vm._v(" Primeiro Anexo")])])])], 1) : _vm._e(), _vm.urlAnexo2 ? _c('div', [_c('b-row', [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.urlAnexo2,
      "target": "_blank"
    }
  }, [_vm._v(" Segundo Anexo")])])])], 1) : _vm._e(), _vm.urlAnexo3 ? _c('div', [_c('b-row', [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.urlAnexo3,
      "target": "_blank"
    }
  }, [_vm._v(" Terceiro Anexo")])])])], 1) : _vm._e(), _c('div', [_c('b-row', [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.urlGoogleMaps,
      "target": "_blank"
    }
  }, [_vm._v(" Ver Localização no Google Maps")])])])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };